import { Controller } from "@hotwired/stimulus"

// Filter values are persisted by Rails when it receives an explicit f[...] URL
// and restored by Rails before the table query runs. This controller only keeps
// GET URLs tidy and makes an empty filter submission explicit with `f=`.
export default class extends Controller {
  connect() {
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.element.addEventListener("submit", this.handleFormSubmit)
    this.removeLegacyStorage()
    this.removeEmptyFilterSentinelFromUrl()
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleFormSubmit)
  }

  isFilterParam(name) {
    return Boolean(name?.match(/^f\[[^\]]+\](\[\])?$/))
  }

  handleFormSubmit(event) {
    const form = event.target
    if (form.tagName !== "FORM") return
    // Other forms live in the same toolbar (saving a filter preset, for one);
    // only the GET forms that query the list carry filter params.
    if (form.method.toLowerCase() !== "get") return

    this.removeEmptyFilterParams(form)
    this.addEmptyFilterSentinel(form)
  }

  removeEmptyFilterParams(form) {
    const inputs = form.querySelectorAll("input, select")
    inputs.forEach(input => {
      if (this.isFilterParam(input.name) && (input.value === "" || input.value === null)) {
        input.disabled = true
      }
    })
  }

  addEmptyFilterSentinel(form) {
    const hasFilters = Array.from(form.elements).some(input => {
      if (!this.isFilterParam(input.name) || input.disabled) return false
      if ((input.type === "radio" || input.type === "checkbox") && !input.checked) return false
      if (input instanceof HTMLSelectElement && input.multiple) {
        return Array.from(input.selectedOptions).some(option => option.value)
      }

      return Boolean(input.value)
    })
    if (hasFilters) return

    const sentinel = document.createElement("input")
    sentinel.type = "hidden"
    sentinel.name = "f"
    sentinel.value = ""
    form.appendChild(sentinel)
  }

  removeLegacyStorage() {
    try {
      const key = window.location.pathname.replace(/^\//, "").replace(/\//g, "_") + "_filters"
      localStorage.removeItem(key)
    } catch (_) {}
  }

  removeEmptyFilterSentinelFromUrl() {
    const url = new URL(window.location)
    if (!url.searchParams.has("f") || url.searchParams.get("f") !== "") return

    url.searchParams.delete("f")
    window.history.replaceState(window.history.state, "", url.toString())
  }

  clear() {
    const url = new URL(window.location)
    Array.from(url.searchParams.keys())
      .filter(key => key === "f" || key.startsWith("f["))
      .forEach(k => url.searchParams.delete(k))
    url.searchParams.set("f", "")

    Turbo.visit(url.toString(), { action: "replace" })
  }
}
